export default __webpack_public_path__ + "static/media/form-header.ea960559.png";